import React, { useState } from 'react';
import Button from '../../../components/ui/Button';
import Select from '../../../components/ui/Select';
import Icon from '../../../components/AppIcon';

const RejectionReasonModal = ({ user, onClose, onConfirm, isSubmitting }) => {
  const [selectedReason, setSelectedReason] = useState('');
  const [error, setError] = useState('');

  const rejectionReasons = [
    { 
      value: '', 
      label: 'Select a reason...' 
    },
    { 
      value: 'insufficient_documentation', 
      label: 'Lack of Sufficient Documentation',
      description: 'Required documents are missing or incomplete'
    },
    { 
      value: 'poor_image_quality', 
      label: 'Poor Image Quality of Documents',
      description: 'Uploaded documents are not clear or legible'
    },
    { 
      value: 'unspecified', 
      label: 'Other / Unspecified',
      description: 'Additional review or clarification required'
    }
  ];

  const handleConfirm = () => {
    if (!selectedReason) {
      setError('Please select a rejection reason');
      return;
    }
    onConfirm(selectedReason);
  };

  const selectedReasonData = rejectionReasons?.find(r => r?.value === selectedReason);

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-lg shadow-xl max-w-md w-full">
        <div className="p-6">
          <div className="flex items-start justify-between mb-4">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 bg-red-100 rounded-full flex items-center justify-center">
                <Icon name="XCircle" size={20} color="var(--color-destructive)" />
              </div>
              <div>
                <h3 className="text-lg font-semibold text-gray-900">Reject Application</h3>
                <p className="text-sm text-gray-500">{user?.name}</p>
              </div>
            </div>
            <button
              onClick={onClose}
              disabled={isSubmitting}
              className="text-gray-400 hover:text-gray-600 transition-colors"
            >
              <Icon name="X" size={20} />
            </button>
          </div>

          <div className="mb-4">
            <p className="text-sm text-gray-600 mb-4">
              Please select a reason for rejecting this application. An email will be automatically sent to the applicant with the rejection details.
            </p>

            <Select
              label="Rejection Reason"
              options={rejectionReasons}
              value={selectedReason}
              onChange={(value) => {
                setSelectedReason(value);
                setError('');
              }}
              required
            />

            {error && (
              <p className="text-sm text-red-600 mt-2">{error}</p>
            )}

            {selectedReasonData?.value && (
              <div className="mt-3 p-3 bg-gray-50 border border-gray-200 rounded-lg">
                <p className="text-xs text-gray-600">
                  <strong>Email will include:</strong> {selectedReasonData?.description}
                </p>
              </div>
            )}
          </div>

          <div className="flex gap-3 justify-end">
            <Button
              variant="outline"
              onClick={onClose}
              disabled={isSubmitting}
            >
              Cancel
            </Button>
            <Button
              variant="destructive"
              onClick={handleConfirm}
              disabled={isSubmitting || !selectedReason}
            >
              {isSubmitting ? 'Sending...' : 'Reject & Send Email'}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RejectionReasonModal;